import { useMemo } from 'react';
import { useRouter } from 'next/router';
import useHeaderMenuData from '@/creditflowresearch/application/HeaderMenu/useHeaderMenuData';
import Region from '@/creditflowresearch/domain/Region';
import ToolService from '@/creditflowresearch/domain/Header/Tool';
import { IUsePanelToolsOptions } from '@/creditflowresearch/domain/vo/ITools';
import { getCurrentPath } from '@framework/router';
import { applyActiveState } from '@/creditflowresearch/ui/common/utils/panels/applyActiveState';

export const usePanelTools = ({ panelId, regionId = Region.getDefaultId() }: IUsePanelToolsOptions) => {
  const {
    mapping,
    isHeaderInitialized,
  } = useHeaderMenuData();
  const { asPath } = useRouter();
  const currentPath = getCurrentPath(asPath);

  const { topOptions, toolsOptions } = useMemo(() => {
    const validation = ToolService.validateToolData(mapping, panelId, isHeaderInitialized, regionId);

    if (!validation.isValid || !validation.activeMapping || !validation.productAbbreviation) {
      return { topOptions: [], toolsOptions: [] };
    }

    const processedTools = ToolService.processToolsForPanel({
      tools: validation.activeMapping.tools,
      activeProductAbbreviation: validation.activeMapping.productAbbreviation,
      activeRegionAbbreviation: validation.activeMapping.regionAbbreviation,
      productAbbreviation: validation.productAbbreviation,
      productId: panelId,
    });

    return {
      topOptions: applyActiveState(processedTools.topOptions, currentPath),
      toolsOptions: applyActiveState(processedTools.toolsOptions, currentPath),
    };
  }, [panelId, regionId, mapping, isHeaderInitialized, currentPath]);

  return {
    topOptions,
    toolsOptions,
  };
};
